export const maintenanceConfig = {
  enabled: false,
  message: 'Stiamo effettuando lavori di manutenzione. Torneremo online a breve.',
  estimatedEnd: '',
  allowedRoles: ['admin'],
};

